
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.02 13.732h3v-3","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.121 11.61a5.5 5.5 0 017.778 0l2.122 2.122M13 17.268h-3v3","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.9 19.39a5.5 5.5 0 01-7.779 0L10 17.267","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.333 26h23.334A2.333 2.333 0 0030 23.667V7.333A2.333 2.333 0 0027.667 5H4.333A2.333 2.333 0 002 7.333v16.334A2.333 2.333 0 004.333 26z","stroke":"#fff","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    